module.exports = __webpack_public_path__ + "static/media/pupiletras.6919acce.png";